export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/XBlue.c2dc5a8f.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};